import { createTheme } from "@mui/material";

const MainTheme = createTheme({});

export default MainTheme;
